import { graphql } from 'react-relay';
export const ConvertPageToFolderQuery = graphql`
	query ConvertPageToFolderQuery($contentId: ID!, $spaceKey: String!) {
		space(key: $spaceKey) {
			id
			spaceTypeSettings {
				enabledContentTypes {
					isFoldersEnabled
				}
			}
		}
		singleContent(id: $contentId) {
			id
			title
			type
			status
			operations {
				operation
				targetType
			}
		}
	}
`;
